import HomeContact from "@/components/home/HomeContact"
function Contact() {
  return (
    <div>
      <HomeContact />
    </div>
  )
}

export default Contact